import { Compass } from "lucide-react";
import Seo from "@/components/Seo";
import { SUGGESTIONS } from "@/components/ScoutChat";

const DESC = "Ask Scout, VoluntoldHQ's coaching assistant, about practices, parents, playing time and the mental game.";

export default function Scout() {
  const open = (message) => window.dispatchEvent(new CustomEvent("open-scout", { detail: message ? { message } : {} }));
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="scout-page">
      <Seo title="Ask Scout, the Coaching Assistant" brand="VoluntoldHQ" description={DESC} path="/scout" />
      <span className="kicker">Scout</span>
      <h1 className="mt-2 font-head font-semibold uppercase text-4xl text-[#1E1E1E]">Ask Scout</h1>
      <p className="mt-3 text-[#6E6E6E]">{DESC}</p>
      <div className="mt-8 grid gap-2 text-left" data-testid="scout-page-starters">
        {SUGGESTIONS.map((s, i) => (
          <button key={s} onClick={() => open(s)} data-testid={`scout-page-starter-${i}`}
            className="w-full text-left text-sm text-[#2D2D2D] border-2 border-[#D3CFC0] hover:border-[#2D2D2D] bg-[#E7E3D9] px-4 py-3 transition-colors">
            {s}
          </button>
        ))}
      </div>
      <button onClick={() => open()} data-testid="scout-page-open-btn" className="mt-6 inline-flex items-center gap-2 bg-[#2D2D2D] text-[#F3F1EC] font-head uppercase tracking-wide text-sm px-6 py-3 hover:bg-[#242424] transition-colors">
        <Compass size={18} className="text-[#E8A33D]" /> Ask Scout
      </button>
    </div>
  );
}
